import { format, isValid } from 'date-fns';
import { fr } from 'date-fns/locale';
import type { Timestamp } from 'firebase/firestore';

export const formatDateSafely = (dateInput: string | Date | Timestamp | undefined | null): string => {
  if (!dateInput) return 'Non spécifié';
  try {
    const date = typeof dateInput === 'string'
      ? new Date(dateInput)
      : (typeof (dateInput as any)?.toDate === 'function'
          ? (dateInput as Timestamp).toDate()
          : (dateInput as Date));
    if (!isValid(date)) return 'Date invalide';
    return format(date, 'PPP', { locale: fr });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Date invalide';
  }
};

export const toISODateSafely = (dateInput: string | Date | Timestamp | undefined | null): string => {
  if (!dateInput) return new Date().toISOString();
  try {
    const date = typeof dateInput === 'string'
      ? new Date(dateInput)
      : (typeof (dateInput as any)?.toDate === 'function'
          ? (dateInput as Timestamp).toDate()
          : (dateInput as Date));
    return isValid(date) ? date.toISOString() : new Date().toISOString();
  } catch (error) {
    console.error('Error converting to ISO date:', error);
    return new Date().toISOString();
  }
};